import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63f03dfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 bg-light p-3" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Shifts", -1))
const _hoisted_6 = { class: "col-12 bg-light p-3" }
const _hoisted_7 = { class: "row height d-flex justify-content-center align-items-center" }
const _hoisted_8 = { class: "col-md-8" }
const _hoisted_9 = { class: "search" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1))
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table table-striped table-sm" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Allow Rider"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Shift Fee"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Start Time"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "End Time"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "shift_date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "City"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Is released"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Action")
  ])
], -1))
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = { class: "text-start" }
const _hoisted_17 = { class: "text-start" }
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { class: "text-start" }
const _hoisted_21 = { class: "text-start" }
const _hoisted_22 = { class: "text-start" }
const _hoisted_23 = { class: "text-start" }
const _hoisted_24 = { class: "btn-group mr-2" }
const _hoisted_25 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_router_link, {
              to: "/shifts/create",
              class: "btn btn-sm btn-primary align-self-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Add Shift")
              ]),
              _: 1
            }),
            _createElementVNode("button", {
              to: "/shifts/releaseall",
              class: "btn btn-sm btn-primary align-self-center",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.releaseall && $setup.releaseall(...args)))
            }, "Release all")
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Search with Name,Email,Phone,Business name",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.search) = $event))
                }, null, 512), [
                  [_vModelText, $setup.search]
                ]),
                _createElementVNode("button", {
                  id: "search-user-btn",
                  class: "btn btn-primary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.searchcall && $setup.searchcall(...args)))
                }, " Search "),
                _createElementVNode("button", {
                  id: "search-clear-btn",
                  class: "btn btn-primary clear",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.searchclear && $setup.searchclear(...args)))
                }, " Clear ")
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("table", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.shifts, (shift) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: shift.id
                  }, [
                    _createElementVNode("td", _hoisted_15, _toDisplayString(shift.id), 1),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(shift.allow_rider), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(shift.shift_fee), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(shift.start_time), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(shift.end_time), 1),
                    _createElementVNode("td", _hoisted_20, _toDisplayString($options.dateOnly(shift.shift_date)), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(shift.city?.name), 1),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(shift.is_released), 1),
                    _createElementVNode("td", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_router_link, {
                          to: `/shifts/${shift.id}/view`,
                          class: "btn btn-sm btn-primary me-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Detail")
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createVNode(_component_router_link, {
                          to: `/shifts/${shift.id}/edit`,
                          class: "btn btn-sm btn-secondary me-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Edit")
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createElementVNode("a", {
                          class: "btn btn-sm btn-danger",
                          onClick: ($event: any) => ($setup.del(shift.id))
                        }, " Delete", 8, _hoisted_25)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_v_pagination, {
      modelValue: _ctx.page,
      "onUpdate:modelValue": [
        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.page) = $event)),
        _cache[5] || (_cache[5] = ($event: any) => ($setup.load($event)))
      ],
      pages: $setup.lastPage,
      "range-size": 1,
      "active-color": "#DCEDFF"
    }, null, 8, ["modelValue", "pages"])
  ], 64))
}